/** @graphql cc **/

import gql from 'graphql-tag';

// @phuang TODO: https://product-fabric.atlassian.net/browse/CTD-3710
export const getEmojiTitleProperty = gql`
	query getEmojiTitlePropertyQuery(
		$contentId: ID
		$status: [String]
		$draftShareId: String
		$skipPublishedFragment: Boolean!
	) {
		content(id: $contentId, draftShareId: $draftShareId, status: $status) {
			nodes {
				id
				emojiTitlePublished: properties(key: "emoji-title-published")
					@skip(if: $skipPublishedFragment) {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
				emojiTitleDraft: properties(key: "emoji-title-draft") {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
				contentProperties {
					latest {
						defaultTitleEmoji
					}
				}
			}
		}
	}
`;
